import { QueryKey } from '@gogame/query';

const NOTIFICATIONS = 'notifications';
const MUTATIONS_MARK_AS_READ = 'markAsRead';
const MUTATIONS_MARK_AS_READ_ALL = 'markAsReadAll';
const notificationsQuery = new QueryKey(NOTIFICATIONS);

export const grid = notificationsQuery.grid();

export const mutations = notificationsQuery.mutations();
export const markAsReadKey = mutations.mutate(MUTATIONS_MARK_AS_READ);
export const markAsReadALLKey = mutations.mutate(MUTATIONS_MARK_AS_READ_ALL);
